import React from "react";
import {
  Box,
  FormControl,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  makeStyles,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import ViewListIcon from "@material-ui/icons/ViewList";
import ViewModuleIcon from "@material-ui/icons/ViewModule";

const useStyles = makeStyles((theme) => ({
  bar: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
    marginBottom: theme.spacing(2),
  },
  search: {
    minWidth: 220,
    [theme.breakpoints.down("sm")]: { minWidth: 0, width: "100%", flexBasis: "100%" },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      backgroundColor: theme.mode === "dark" ? "#374151" : "#fff",
    },
  },
  select: {
    minWidth: 140,
    [theme.breakpoints.down("sm")]: { minWidth: 0, flex: "1 1 calc(50% - 6px)" },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      backgroundColor: theme.mode === "dark" ? "#374151" : "#fff",
    },
  },
  spacer: {
    flex: 1,
    [theme.breakpoints.down("sm")]: { display: "none" },
  },
  viewToggle: {
    display: "inline-flex",
    border: `1px solid ${theme.mode === "dark" ? "#4B5563" : "#e5e7eb"}`,
    borderRadius: 10,
    overflow: "hidden",
    backgroundColor: theme.mode === "dark" ? "#1f2937" : "#fff",
  },
  viewBtn: {
    borderRadius: 0,
    [theme.breakpoints.down("sm")]: { minHeight: 44, minWidth: 44 },
  },
  actions: {
    display: "flex",
    gap: 8,
    alignItems: "center",
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      flex: "1 1 100%",
      "& > *": { flex: "1 1 auto" },
      "& .MuiButton-root": { minHeight: 44 },
    },
  },
  viewBtnActive: {
    color: theme.palette.primary.main,
    backgroundColor: theme.mode === "dark" ? "rgba(79,70,245,0.16)" : "#eef0ff",
  },
}));

const CampaignsBrowseBar = ({
  searchValue,
  onSearch,
  searchPlaceholder = "Buscar",
  typeValue,
  onTypeChange,
  typeOptions = [],
  statusValue,
  onStatusChange,
  statusOptions = [],
  viewMode = "list",
  onViewModeChange,
  actions,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.bar}>
      <TextField
        placeholder={searchPlaceholder}
        type="search"
        variant="outlined"
        size="small"
        value={searchValue}
        onChange={onSearch}
        className={classes.search}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" />
            </InputAdornment>
          ),
        }}
      />
      {typeOptions.length > 0 && (
      <FormControl variant="outlined" size="small" className={classes.select}>
        <Select
          displayEmpty
          value={typeValue}
          onChange={(e) => onTypeChange(e.target.value)}
        >
          {typeOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      )}
      {statusOptions.length > 0 && (
      <FormControl variant="outlined" size="small" className={classes.select}>
        <Select
          displayEmpty
          value={statusValue}
          onChange={(e) => onStatusChange(e.target.value)}
        >
          {statusOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      )}
      <Box className={classes.spacer} />
      <Box className={classes.viewToggle}>
        <Tooltip title="Vista lista">
          <IconButton
            size="small"
            className={`${classes.viewBtn} ${viewMode === "list" ? classes.viewBtnActive : ""}`}
            onClick={() => onViewModeChange("list")}
          >
            <ViewListIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Vista cuadrícula">
          <IconButton
            size="small"
            className={`${classes.viewBtn} ${viewMode === "grid" ? classes.viewBtnActive : ""}`}
            onClick={() => onViewModeChange("grid")}
          >
            <ViewModuleIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      {actions && <Box className={classes.actions}>{actions}</Box>}
    </Box>
  );
};

export default CampaignsBrowseBar;
